import React from 'react';

import {
  AddSectionContainer,
  AddSectionHeader,
  AddSectionButton,
} from 'styles/pages/web-pages';

const AddSection = ({ data }) => (
  <AddSectionContainer>
    <AddSectionHeader>
      <AddSectionButton
        title="Add Section"
        containerStyle={{
          backgroundColor: '#000',
          color: '#fff',
          fontWeight: 'bold',
          opacity: 0.5,
        }}
      />
    </AddSectionHeader>
  </AddSectionContainer>
);

export default AddSection;
